import { UniqueUserId, UserClickFields, ViewContentFields } from '@xylabs/pixel'
import { delay } from '@xylabs/sdk-js'

import { Cart } from 'business-logic/cart/hooks'
import { CoinUserEventHandlerBase } from './CoinUserEventHandlerBase'
import { CustomProperties } from './CustomProperties'
import { RedditEvents } from './Reddit'
import { TestData } from './TestData'

export class RedditEventHandler<T extends Record<string, unknown>> extends CoinUserEventHandlerBase<T> {
  private events = new RedditEvents<CustomProperties>()

  async emailCollected(_fields: { email: string }) {
    await delay(0)
  }

  async accountCreated() {
    await delay(0)
  }

  async shareCompleted() {
    await delay(0)
  }

  async buyticketsCompleted() {
    await delay(0)
  }

  async installCompleted() {
    await delay(0)
  }

  async funnelCompleted() {
    await delay(0)
  }

  async offerRequested() {
    await delay(0)
  }

  async feedbackScoreCollected() {
    await delay(0)
  }

  async feedbackSourceCollected() {
    await delay(0)
  }

  async goodFeedbackRequested() {
    await delay(0)
  }

  async badFeedbackRequested() {
    await delay(0)
  }

  async contactInfoComplete() {
    await delay(0)
  }

  async addressInfoComplete() {
    await delay(0)
  }

  async paymentInfoComplete() {
    await delay(0)
  }

  async addToCart() {
    await this.events.addToCart().send(this.buildCustomProperties())
  }

  async purchaseCompleted() {
    const cart = Cart.get()
    await this.events.purchase().send(
      this.buildCustomProperties({
        currency: 'USD',
        value: cart.getValue(),
      }),
    )
  }

  async userClick(_fields: UserClickFields) {
    await delay(0)
  }

  async initiateCheckout() {
    await delay(0)
  }

  async purchaseAttempted() {
    await delay(0)
  }

  async purchaseFailed() {
    await delay(0)
  }

  async upsellViewed() {
    await delay(0)
  }

  async upsellUnavailable() {
    await delay(0)
  }

  async upsellAccepted() {
    await delay(0)
  }

  async trialStarted() {
    await delay(0)
  }

  async funnelStarted() {
    await delay(0)
  }

  async upsellSucceeded() {
    await this.purchaseCompleted()
  }

  async upsellFailed() {
    await delay(0)
  }

  async testStarted() {
    await delay(0)
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async customEvent(name: string, data: T) {
    await delay(0)
  }

  async viewContent(fields: ViewContentFields) {
    await this.events.viewContent().send(this.buildCustomProperties<ViewContentFields>(fields))
  }

  buildCustomProperties<T>(data?: T): T | CustomProperties {
    const cart = Cart.get()
    const coinId = new UniqueUserId().id
    const testData = new TestData().data
    return {
      ...data,
      coinId,
      itemSet: cart.getItemSet(),
      testData,
    }
  }
}
